import React from 'react';

import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import usePaths from 'hooks/use-paths';
import useUI from 'shared/hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { useBuyItAgainCarousel } from './use-buy-it-again-carousel';

export function BuyItAgainCarousel(): JSX.Element | null {
  const { dispensary } = useDispensary();
  const UI = useUI();
  const { href } = usePaths({ dispensary });

  const hasUserPaths = Boolean(UI.isEmbedded) || Boolean(UI.isStoreFront);
  const ordersPath = hasUserPaths ? `${href}/user/orders` : '/account/orders';

  const { products, loading, handleViewAllClick, viewportVisibility } = useBuyItAgainCarousel();

  if (!loading && !products.length) {
    return null;
  }

  return (
    <ProductCarousel
      ref={viewportVisibility.ref}
      products={products}
      isLoading={loading}
      title='Buy it again'
      href={ordersPath}
      onViewAllClick={() => handleViewAllClick(ordersPath)}
    />
  );
}
